export default __webpack_public_path__ + "static/media/target-left-img.c4697d2f.png";